import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface EmailGuestsState {
  // set of template IDs
  selectedTemplateId: string;
  searchText: string;
  testEmail: string;
}

const formSlice = createGenericFormSlice({
  name: "sendEmail",
  initialState: {} as SliceState<EmailGuestsState>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const sendEmailReducer = formSlice.reducer;
export default sendEmailReducer;
